<template>
  <div class="app has-header">
    <div class="header main">
        <div class="align-left">
            <dateselectionheader
                    :label="dateSelectionStart.format('MMMM') + ' ' + dateSelectionStart.format('YYYY')"
                    @PrevDate="setDateSelection(dateSelectionStart.add(-1, 'month'), true)"
                    @NextDate="setDateSelection(dateSelectionStart.add(1, 'month'), true)"
                    @CalendarOpen="OpenDateSelection"
                    @SetToday="setDateSelection($helpers.getCurrentMonthMomentTZ(), true)"/></div>
        <div class="align-middle">
            <headerbuttonstack :state="headerButtons"/>
        </div>
        <div class="align-right"></div>
    </div>
    <div class="scrollbar-container">
        <datatable :state="dataTableState"/>
    </div>
    <div v-if="loading" class="loading-md bg">
        <i class="fas fa-spinner"></i>
    </div>

  </div>

</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'storeeventoverview',
  components: {
  },
  data () {
    return {
      storeevents: [],
      selectedStoreEvents: [],
      storeEventMap: {},
      storeEventId: null,
      dateSelectionStart: this.$helpers.getCurrentMonthMomentUTC(),
      holidayYear: this.$helpers.getCurrentMonthMomentUTC().year(),
      $helpers: this.$helpers,
      loading: true,
      
    }
  },
  created: function () {
    this.setDateSelection(this.$helpers.getCurrentMonthMomentUTC(), true);
    this.refresh();
  },
  computed: {
    ...mapGetters([
        'rosterFromTo', 
        'storeSettings'
    ]),
    dataTableState(){
        let view = this;
        let state = {};
        let month = this.rosterFromTo.month;
        let year = this.rosterFromTo.year;
        let shifts = Object.values(this.storeEventMap).filter(item => {
            let from = view.$helpers.getMomentFromStringTZ(item.from);
            return from.month() == month && from.year() == year;
        });
        state = this.$helpers.GetDataTableStateFromKeyLabelObject({
            name: this.$t('pages.employeeData.name'),
            color: this.$t('store.events.color'),
            from: this.$t('global.general.from'),
            to: this.$t('global.general.to'),
            federalHoliday: this.$t('store.events.nationalHoliday'),
            bankHoliday: this.$t('store.events.bankHoliday'),
            contractHoliday: this.$t('store.events.contractHoliday'),
            active: this.$t('global.general.active'),
        }, shifts);
        
        Object.values(state.headerMap).forEach(e => e.align = 'center');
        
        state.headerMap['name'].sort = true;
        state.headerMap['name'].align = 'center';
        state.headerMap['name'].DisplayLabel = (i) => {return i.name};
        state.headerMap['name'].width = '150px';
        state.headerMap['name'].OnChange = (newVal, storeEvent) => {
            storeEvent.name = newVal;
            view.UpdateStoreEvent(storeEvent);
        }
        
        state.headerMap['color'].align = 'center';
        state.headerMap.color.componentTypeRow = 'colorpickicon';
        state.headerMap.color.componentStateBuilder = (storeEvent) => {
            return {
                propContainer: {color: storeEvent.color},
                customEvents: {
                    Update: (color) => {
                        storeEvent.color = color;
                        view.UpdateStoreEvent(storeEvent);
                    }
                }
            };
        };
        
        state.headerMap['from'].sort = true;
        state.headerMap['from'].DisplayLabel = (i) => view.$helpers.getMomentFromStringTZ(i.from).format('DD.MM.YYYY HH:mm');
        state.headerMap['from'].DisabledCheck = (i) => {return i.published};
        state.headerMap['from'].align = 'center';
        state.headerMap['from'].clickOptions = {icon: 'fas fa-pencil-alt', action: ($event, entry) => {
            view.$helpers.DateSelectionPopup($event, entry.data.from, (newVal, newValMoment) => {
                let prevFrom = entry.data.from;
                let prevTo = entry.data.to;
                entry.data.from = newVal;
                
                let from = this.$helpers.getMomentFromStringTZ(entry.data.from);
                let to = this.$helpers.getMomentFromStringTZ(entry.data.to);
                let endOfWeek = from.clone().endOf('isoWeek').add(1, 'days').startOf('day');
                if(to > endOfWeek){
                    to = endOfWeek;
                }
                if(from < to){
                    entry.data.from = from.format();
                    entry.data.to = to.format();
                    view.$helpers.EditCall('/api/sec/storeevent', entry.data, () => {
                        view.$set(view.storeEventMap, entry.data.id, entry.data);
                    }, null, () => {
                        entry.data.from = prevFrom;
                        entry.data.to = prevTo;
                    });
                } else {
                    entry.data.from = prevFrom;
                    entry.data.to = prevTo;
                    view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('store.events.eventDateInvalid'));
                }
                
            });
        }};
        state.headerMap['to'].sort = true;
        state.headerMap['to'].label = this.$t('global.general.to');
        state.headerMap['to'].DisplayLabel = (i) => view.$helpers.getMomentFromStringTZ(i.to).format('DD.MM.YYYY HH:mm');
        state.headerMap['to'].DisabledCheck = (i) => {return i.published};
        state.headerMap['to'].align = 'center';
        state.headerMap['to'].clickOptions = {icon: 'fas fa-pencil-alt', action: ($event, entry) => {
                view.$helpers.DateSelectionPopup($event, entry.data.to, (newVal, newValMoment) => {
                    let prevFrom = entry.data.from;
                    let prevTo = entry.data.to;
                    entry.data.to = newVal;
                    
                    let from = this.$helpers.getMomentFromStringTZ(entry.data.from);
                    let to = this.$helpers.getMomentFromStringTZ(entry.data.to);
                    let endOfWeek = from.clone().endOf('isoWeek').add(1, 'days').startOf('day');
                    if(to > endOfWeek){
                        to = endOfWeek;
                    }
                    if(from < to){
                        entry.data.from = from.format();
                        entry.data.to = to.format();
                        view.$helpers.EditCall('/api/sec/storeevent', entry.data, () => {
                            view.$set(view.storeEventMap, entry.data.id, entry.data);
                        }, null, () => {
                            entry.data.from = prevFrom;
                            entry.data.to = prevTo;
                        });
                    } else {
                        entry.data.from = prevFrom;
                        entry.data.to = prevTo;
                        view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('global.notifications.updateFailed'));
                    } 
                    
                });
            }};
        state.headerMap.federalHoliday.componentTypeRow = 'checkbox';
        state.headerMap.federalHoliday.componentStateBuilder = (storeEvent) => {
            return {
                    propContainer: {value: storeEvent.federalHoliday, data: storeEvent},
                    customEvents: {
                        Update: ($event, value, storeEvent) => {
                            storeEvent.federalHoliday = value;
                            view.UpdateStoreEvent(storeEvent);
                        }
                    }
                };
        };
        state.headerMap.bankHoliday.componentTypeRow = 'checkbox';
        state.headerMap.bankHoliday.componentStateBuilder = (storeEvent) => {
            return {
                    propContainer: {value: storeEvent.bankHoliday, data: storeEvent},
                    customEvents: {
                        Update: ($event, value, storeEvent) => {
                            storeEvent.bankHoliday = value;
                            view.UpdateStoreEvent(storeEvent);
                        }
                    }
                };
        };
        state.headerMap.contractHoliday.componentTypeRow = 'checkbox';
        state.headerMap.contractHoliday.componentStateBuilder = (storeEvent) => {
            return {
                    propContainer: {value: storeEvent.contractHoliday, data: storeEvent},
                    customEvents: {
                        Update: ($event, value, storeEvent) => {
                            storeEvent.contractHoliday = value;
                            view.UpdateStoreEvent(storeEvent);
                        }
                    }
                };
        };
        state.headerMap.active.componentTypeRow = 'checkbox';
        state.headerMap.active.componentStateBuilder = (storeEvent) => {
            return {
                    propContainer: {value: storeEvent.active, data: storeEvent},
                    customEvents: {
                        Update: ($event, value, storeEvent) => {
                            storeEvent.active = value;
                            view.UpdateStoreEvent(storeEvent);
                        }
                    }
                };
        };
        
        
        state.headerMap['actions'] = {buttons:[
                {icon: 'fas fa-pencil-alt', action: ($event, data) => view.EditStoreEvent(data)},
                {icon: 'fas fa-trash', action: ($event, data) => view.DeleteEventPopup(data)},
            ]};
        state.headerMap['actions'].width = '100px';

        return state;
    },
    headerButtons() {
        let view = this;
        let state = {buttons: [
                {
                    classes: "",
                    type: "block",
                    icon: "fa-refresh",
                    click: () => { view.refresh() },
                    tooltip: this.$t('global.ui.refresh'),
                },
                {
                    classes: "",
                    type: "block label-corner",
                    label: 'E',
                    icon: "fa-plus",
                    click: () => { view.NewStoreEventPopup() },
                    tooltip: this.$t('store.events.createEvent'),
                },
                {
                    classes: "",
                    type: "block  label-corner",
                    label: 'F',
                    icon: "fa-plus",
                    click: () => { view.CreateHoliday() },
                    tooltip: this.$t('store.events.createHolidays'),
                },
                /*{
                    classes: "delete",
                    type: "block",
                    disabled: (view.shiftsSelected.length <= 0),
                    icon: "fa-trash",
                    click: () => { view.DeleteSelectedShifts() },
                    show: (view.shiftsSelected.length > 0),
                    tooltip: this.$t('roster.view.deleteSelectedShifts'),
                },*/
            ]};
            return state;
        },
        formattedTimeMap() {
          let map = {}
          for(let i = 0; i<this.storeevents.length; i++){
              let event = this.storeevents[i];
              map[event.id] =  { from: this.$helpers.getMomentFromString(event.from).format("DD.MM.YYYY HH:mm"), 
                                 to: this.$helpers.getMomentFromString(event.to).format("DD.MM.YYYY HH:mm")}
          }
          return map;
        },
        storeId() {
            return this.$store.state.storeId;
        },
        monthDisplay: function() {
            if(this.dateSelectionStart != null){
                return this.dateSelectionStart.format('MMM YYYY');
            } else {
                return '-';
            }
                
        },
  },
  watch: {
    rosterFromTo(newVal, oldVal) {
        if(newVal != null && this.$store.state.jwt != undefined && this.$store.state.storeId != undefined && newVal.year != oldVal.year){
            this.refresh();
        }
    },
    storeId(newVal, oldVal) {
        console.log("Changed storeId: "+newVal);
        this.refresh();
    }
  },
  // methods that implement data logic.
  methods: {
    DeleteEventPopup(storeEvent){

        let view = this;
        window.app.popupalerts.push({header: this.$t('store.events.deleteEvent'), description: this.$t('store.events.event') + ' ' + storeEvent.name + '. ' + this.$t('global.ui.deleteQuery'), callbackAccept: function(popup){
                //popup.loading = true;
                view.DeleteStoreEvent(storeEvent);
                popup.hidden = true;
            }, callbackCancel: function(popup){
                popup.loading = false;
                popup.hidden = true;
            }});
    },
    CreateHoliday(){
        let datafill = this.$helpers.GetDataFillStateFromKeyLabelObject({year: this.$t('global.general.year')}, (data) => this.NewHolidays(data.year));
        this.$helpers.OpenPopup({
            type: 'datafill',
            componentState: datafill,
            header: this.$t('store.events.createHolidays'),
            expanded: true,
            centered: true
        });
    },
    NewStoreEventPopup(){
        let eventitems = [];
        Object.values(this.storeEventMap).sort((a, b) => {
            let aFrom = this.$helpers.getMomentFromStringTZ(a.from);
            let bFrom = this.$helpers.getMomentFromStringTZ(b.from);
            return bFrom.unix() - aFrom.unix();
        }).forEach(event => {
            
            let to = this.$helpers.getMomentFromStringTZ(event.to);
            if(to.hours() == 0 && to.minutes() == 0){
                //subtract 1 day because brainlets don't understand what an exclusive time range is
                to.add(-1,'days');
            }
            
            eventitems.push({label: event.name+' '+this.$helpers.getMomentFromStringTZ(event.from).format("DD.MM.YYYY")+' - '+to.format("DD.MM.YYYY"), name: event.name, value: event.id});
        });
        let view = this;
        this.$helpers.PopupNewEvent({currentTarget: null}, this.$helpers.getMomentTZ().startOf('day'), eventitems, null, null,  (storeEvent) => {
                storeEvent.from.year(storeEvent.fromDate.year());
                storeEvent.from.month(storeEvent.fromDate.month());
                storeEvent.from.date(storeEvent.fromDate.date());

                storeEvent.to.year(storeEvent.toDate.year());
                storeEvent.to.month(storeEvent.toDate.month());
                storeEvent.to.date(storeEvent.toDate.date());

                let endOfWeek = storeEvent.from.clone().endOf('isoWeek').add(1, 'days').startOf('day');
                if(storeEvent.to.hours() == 0 && storeEvent.to.minutes() == 0){
                    //add 1 day because brainlets don't understand what an exclusive time range is
                    storeEvent.to.add(1,'days');
                }
                
                if(storeEvent.to > endOfWeek){
                    storeEvent.to = endOfWeek;
                }
                if(storeEvent.from < storeEvent.to){
                    view.NewStoreEvent(storeEvent);
                } else {
                    view.$helpers.error(view.$t('global.ui.createFailed'), view.$t('global.notifications.updateFailed'));
                } 
                
            });
    },
    EditStoreEvent(storeEventT){
        let view = this;
        let storeEvent = Object.assign({}, storeEventT);
        let to = this.$helpers.getMomentFromStringTZ(storeEvent.to);
        if(to.hours() == 0 && to.minutes() == 0){
            //subtract 1 day because brainlets don't understand what an exclusive time range is
            to.add(-1,'days');
            storeEvent.to = to.format();
        }
        this.$helpers.PopupEditEvent({currentTarget: null}, storeEvent, (storeEvent) => {
                console.log(storeEvent);

                let endOfWeek = storeEvent.from.clone().endOf('isoWeek').add(1, 'days').startOf('day');
                if(storeEvent.to.hours() == 0 && storeEvent.to.minutes() == 0){
                    //add 1 day because brainlets don't understand what an exclusive time range is
                    storeEvent.to.add(1,'days');
                }
                if(storeEvent.to > endOfWeek){
                    storeEvent.to = endOfWeek;
                }
                if(storeEvent.from < storeEvent.to){
                    view.UpdateStoreEvent(storeEvent);
                } else {
                    view.$helpers.error(view.$t('global.ui.createFailed'), view.$t('global.notifications.updateFailed'));
                } 
                
            });
    },
    OpenDateSelection($event){
        let view = this;
        this.$helpers.OpenDatepickerPopup(
            { viewsEnabled: ['M'], date: this.dateSelectionStart.clone() },
            {
                OnDateSelect: (date) => { view.setDateSelection(date, true) },
            },
            { elRelative: $event ? $event.currentTarget : null });
    },
    refresh: function() {
        let view = this;
        this.selectedStoreEvents = [];
        this.loading = true;
        this.loadStoreEvents()
        .then(response=>{
            view.updateStoreEvents(response.data)
            this.loading = false; 
        })
        .catch(function (error) {
            console.log(error)
        });
    },
    toggleDatePicker($event) {

        let view = this;
        this.$helpers.OpenDatepickerPopup(
            { viewsEnabled: ['M'], date: this.dateSelectionStart.clone() },
            {
                OnDateSelect: (date) => { view.onDatePicked(date) },
            },
            { elRelative: $event ? $event.currentTarget : null });
    },
    setDateSelection(date, calculateRosterFromTo){
        let fixedDate = this.$helpers.getMomentTZ().year(date.year()).month(date.month()).date(date.date()).startOf('day');
        this.dateSelectionStart = fixedDate;
                
        if(calculateRosterFromTo){
            //update vuex store with calculated from to => triggers reload of data via refresh
            let rosterFromTo = this.$helpers.CalculateRosterFromTo(date);
            this.$store.commit('setRosterFromTo', {rosterFromTo: rosterFromTo});
        } else {
            //dont update vuex from to, only update client side view
        }
    },
    onDatePicked(date){        
        this.setDateSelection(date, true);
    },
    updateSelectedStoreEvents(items) {
        this.selectedStoreEvents = items
    },
    NewStoreEvent(storeEvent){
        let view = this;
        let url = '/api/sec/storeevent';
        
        let params = {
            storeId: this.$store.state.storeId
        };
        let payload = {
            name: storeEvent.name,
            from: storeEvent.from,
            to: storeEvent.to,
            federalHoliday: storeEvent.federalHoliday,
            bankHoliday: storeEvent.bankHoliday,
            contractHoliday: storeEvent.contractHoliday,
            description: "",
            color: storeEvent.color,
            shiftCreationMode: storeEvent.shiftCreationMode,
            createWithTemplates: storeEvent.createWithTemplates,
            copyEventId: storeEvent.copyEventId,
            allowTemplateAssignment: storeEvent.allowTemplateAssignment
        };
        if(payload.shiftCreationMode == 2){
            payload.createWithTemplates = false;
        }
        if(payload.copyEventId != null && payload.shiftCreationMode != 2){
            let copyEventFrom = this.$helpers.getMomentFromStringTZ(this.storeEventMap[payload.copyEventId].from);
            let copyEventTo = this.$helpers.getMomentFromStringTZ(this.storeEventMap[payload.copyEventId].to)

            let copyDayIndex = copyEventTo.diff(copyEventFrom, 'minutes') > 1440 ?  null: copyEventFrom.isoWeekday();
            let newDayFrom = this.$helpers.getMomentFromStringTZ(payload.from);
            let newDayTo = this.$helpers.getMomentFromStringTZ(payload.to);

            let newDayIndex = newDayTo.diff(newDayFrom, 'minutes') > 1440 ?  null : newDayFrom.isoWeekday();
            payload.copyDayIndex = copyDayIndex;
            payload.newDayIndex = newDayIndex;
        }
        this.axios({
            method: 'post',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            let event = response.data.data;
            let eventId = response.data.data.id;

            let fromMoment = view.$helpers.getMomentFromStringTZ(response.data.data.from);
            let toMoment = view.$helpers.getMomentFromStringTZ(response.data.data.to);
            view.$store.commit('invalidateState', { states: [ 'holidayMapState' ] })
            view.$set(view.storeEventMap, response.data.data.id, response.data.data);
            view.$helpers.success(view.$t('store.events.creationSuccessful'), view.$t('store.events.creationSuccessful'))
            if(storeEvent.allowTemplateAssignment && storeEvent.copyEventId == null && storeEvent.createWithTemplates && event.shiftCreationMode != 2){
                
                let templates = [];
                let validFrom = fromMoment.clone().startOf('week');
                let validTo = fromMoment.clone().endOf('week').add(1, 'days').startOf('day');
                view.loadShiftTemplatesPagedCompletely(validFrom, validTo)
                .then(data => {
                    let shiftTemplates = data;
                    shiftTemplates.filter(s => s.eventId == null).forEach(s => {
                        let overlapsEvent = false;
                        let fromUtc = view.$helpers.getMomentFromStringTZ(s.from, 'HH:mm');
                        let toUtc = view.$helpers.getMomentFromStringTZ(s.to, 'HH:mm')
                        let templateFromMoment = fromMoment.clone().hours(fromUtc.hours()).minutes(fromUtc.minutes());
                        let templateToMoment = fromMoment.clone().hours(toUtc.hours()).minutes(toUtc.minutes());
                        let breakFromMoment = null;
                        if(s.breakFrom){
                            let breakFromUtc = view.$helpers.getMomentFromStringTZ(s.breakFrom, 'HH:mm');
                            breakFromMoment = fromMoment.clone().hours(breakFromUtc.hours()).minutes(breakFromUtc.minutes());
                        }
                        let weekDays = [];
                        s.weekDays.forEach(w => {
                            templateFromMoment.isoWeekday(w);
                            templateToMoment.isoWeekday(w);
                            if(templateToMoment <= templateFromMoment){
                                templateToMoment.add(1,'days')
                            }
                                        
                            if(toMoment > templateFromMoment && fromMoment < templateToMoment && templateFromMoment >= fromMoment){
                                weekDays.push(w);
                            }
                                        
                        })
                        if(weekDays.length > 0){
                            let tempTemplate = JSON.parse(JSON.stringify(s));
                            tempTemplate.weekDays = weekDays;
                            tempTemplate.eventId = eventId;
                            tempTemplate.from = templateFromMoment;
                            tempTemplate.to = templateToMoment;
                            tempTemplate.breakFrom = breakFromMoment;
                            templates.push(tempTemplate);
                        }
                                
                    });
                    if(templates.length > 0){
                        view.CreateShiftTemplateMulti(templates);
                    }
                }).catch(function (error) {
                    view.$helpers.error(view.$t('global.notifications.error'), 'Fehler beim Laden der Schichtpläne!');
                    console.log(error)
                })

                        
            }
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.createFailed'));
            console.log(error)
        })

    },
    loadShiftTemplatesPagedCompletely : function(from, to, page = 1, data = []) {

        let url = '/api/sec/shifttemplate';
        let params = {
            storeId: this.$store.state.storeId,
            validFrom: from.format(),
            validTo: to.format(),
            validGroup: true,
            page: page,
        };

        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
           
        }).then(response => {

            if (response.data.length < 1 ) {
                return data;
            } else {
                data.push(...response.data);
                 return this.loadShiftTemplatesPagedCompletely (from, to, page+1, data);
            }


        })


    },
    
    CreateShiftTemplateMulti: function(shiftTemplates){
        //console.log(JSON.stringify(shiftTemplate));
        let view = this;
        let url = '/api/sec/shifttemplate/multi';
                
        let params = {
            storeId: this.$store.state.storeId
        }
        let payload = {
            requests: []
        }
                
        shiftTemplates.forEach( shiftTemplate => {
            let from = shiftTemplate.from;
               
            let to = from.clone().hours(shiftTemplate.to.hours()).minutes(shiftTemplate.to.minutes());
                    
            if(to <= from){
                to = to.add(1, 'days');
            } 

            let breakValue = shiftTemplate.breakValue;
            let breakFrom = shiftTemplate.breakFrom;
            let invalidBreak = false;
            let invalidSpot = shiftTemplate.spotId ? false : true;
            if(shiftTemplate.breakFrom == null || shiftTemplate.autoBreak){
                
                breakValue = view.$helpers.CalculateAutoBreakValueForPlanShift(false, from, to, view.storeSettings);
                breakFrom = null;
            } else {
                breakFrom = from.clone().hours(breakFrom.hours()).minutes(breakFrom.minutes());

                if(breakFrom < from){
                    breakFrom.add(1, 'days');
                }

            }

            let item = {
                groupId: shiftTemplate.groupId,
                from: from.format('HH:mm'),
                to: to.format('HH:mm'),
                spotId: shiftTemplate.spotId,
                eventId: shiftTemplate.eventId ? shiftTemplate.eventId : null,
                count: shiftTemplate.count,
                description: shiftTemplate.description,
                skillMultiplier: 1,
                breakFrom: breakFrom == null ? null : breakFrom.format('HH:mm'),
                breakValue: breakValue,
                workValueMultiplier:1,
                workValue: -1,
                holidayWorkValue: -1,
                weekDays: shiftTemplate.weekDays ? shiftTemplate.weekDays : [],
            }
            payload.requests.push(item);
        })
                
        if(payload.requests.length > 0){
            this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.$helpers.success(view.$t('store.events.creationSuccessful'), view.$t('store.events.shiftTemplateCreationSuccessful'))
                        
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.ui.createFailed'), view.$t('store.events.shiftTemplateCreationFailed'));
            })
        }
    },
    NewHolidays: function(year){
        
        let view = this;
        let url = '/api/sec/storeevent/holidays/default';
        
        let params = {
            storeId: this.$store.state.storeId,
            years: year
        };
        

        this.axios({
            method: 'post',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
        }).then(response => {
            view.refresh();
            
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.createFailed'));
            console.log(error)
        })

    },
    
    UpdateStoreEvent: function(storeEvent){
        
        let view = this;
        let url = '/api/sec/storeevent';
        
        let params = {
            storeId: this.$store.state.storeId
        };
        let payload = {
          id: storeEvent.id,
          name: storeEvent.name,
          from: storeEvent.from,
          to: storeEvent.to,
          federalHoliday: storeEvent.federalHoliday,
          bankHoliday: storeEvent.bankHoliday,
          contractHoliday: storeEvent.contractHoliday,
          description: storeEvent.description,
          color: storeEvent.color,
          shiftCreationMode: storeEvent.shiftCreationMode,
          active: storeEvent.active,
          updateFields: ["name", "from", "to", "federalHoliday", "bankHoliday", "contractHoliday", "description", "color", "shiftCreationMode", "active"]
        };

        this.axios({
            method: 'put',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.$store.commit('invalidateState', { states: [ 'holidayMapState' ] })
            view.$set(view.storeEventMap, payload.id, payload);
            view.$helpers.success(view.$t('global.notifications.success'), '');
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.updateFailed'));
            console.log(error)
        })

    },
    activateStoreEvent: function(id){
        
        let view = this;
        let url = '/api/sec/storeevent';
        
        let params = {
            storeId: this.$store.state.storeId
        };
        let payload = {
          id: id,
          active: true,
          updateFields: ["active"]
        };

        this.axios({
            method: 'put',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.$store.commit('invalidateState', { states: [ 'holidayMapState' ] })
            const index = view.storeevents.findIndex(event => event.id === id) // find the businessunit index 
            if (~index) {
                view.storeevents[index].active = true;   
            }   
            view.storeEventMap[id].active = true;
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.updateFailed'));
            console.log(error)
        })

    },
    deactivateStoreEvent: function(id){
        
        
        let view = this;
        let url = '/api/sec/storeevent';
        
        let params = {
            storeId: this.$store.state.storeId
        };
        let payload = {
          id: id,
          active: false,
          updateFields: ["active"]
        };

        this.axios({
            method: 'put',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.$store.commit('invalidateState', { states: [ 'holidayMapState' ] })
            const index = view.storeevents.findIndex(event => event.id === id) // find the businessunit index 
            if (~index) {
                view.storeevents[index].active = false;   
            }   
            view.storeEventMap[id].active = false;
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.updateFailed'));
            console.log(error)
        })

    },
    DeleteStoreEvent(storeEvent){
        let view = this;
        let url = '/api/sec/storeevent';
        
        let params =  {
            id: storeEvent.id,
            storeId: this.$store.state.storeId
        }
       
        
        this.axios({
            method: 'delete',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            view.$store.commit('invalidateState', { states: [ 'holidayMapState' ] })
            view.$delete(view.storeEventMap, storeEvent.id);
             
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.deleteFailed'));
            console.log(error)
        })
    },
    multiDeleteStoreEvent: function(evt){
        evt.preventDefault();
        
        let view = this;
        let url = '/api/sec/storeevent/any/delete';
        
       
        let params = {
            storeId: this.$store.state.storeId
        }
        
        let payload = {ids: []};
        this.selectedStoreEvents.forEach(item => payload.ids.push(item.id));
        
        this.axios({
            method: 'post',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.$store.commit('invalidateState', { states: [ 'holidayMapState' ] })
            view.refresh();
            
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.deleteFailed'));
            console.log(error)
        })

    },
    loadStoreEvents : function() {
        let view = this;
        let url = '/api/sec/storeevent';
        let params = {
            storeId: this.$store.state.storeId,
            from: this.$helpers.getMomentTZ().year(this.$store.state.rosterFromTo.year).startOf('year').add(-1,'year').format(),
            to: this.$helpers.getMomentTZ().year(this.$store.state.rosterFromTo.year).startOf('year').add(1,'year').format()
        };
        
      
        return this.axios({
            method: 'get',
            params: params,
            headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
            url: url
        })
        
        
    },
    
    updateStoreEvents: function(data) {
        let tevents = [];
        let tMap = {};
        for (let i = 0; i < data.length; i++) { 
            tevents.push(data[i]);
            tMap[data[i].id] = data[i];
           
        }
      
        this.storeevents = tevents;
        this.storeEventMap = tMap;
    },
    
  },

}
</script>

<style scoped>
    .scrollbar-container{
        padding: 20px;
    }
</style>
